import type { TFunction } from 'i18next';

export const SegmentErrorMessagesMap = {
  NOT_EXISTENT: 'non-existent segment ids in normalized definition',
  MALFORMED: 'malformed segment ids in normalized definition',
  NOT_READY: 'non-ready segments in normalized definition',
  ARCHIVED: 'archived segments in normalized definition',
  NOT_LEAF: 'non-leaf segments in normalized definition',
} as const;

export const parseSegmentErrorMessages = (message: string, removeToSave = false, t: TFunction) => {
  if (message === SegmentErrorMessagesMap.NOT_EXISTENT) {
    return t('Audience includes non existing segments.') + (removeToSave ? t(' Remove to save.') : '');
  }
  if (message === SegmentErrorMessagesMap.MALFORMED) {
    return t('Audience includes malformed segments.') + (removeToSave ? t(' Remove to save.') : '');
  }
  if (message === SegmentErrorMessagesMap.NOT_READY) {
    return t('Audience includes expired segments.') + (removeToSave ? t(' Remove to save.') : '');
  }
  if (message === SegmentErrorMessagesMap.ARCHIVED) {
    return t('Audience includes archived segments.') + (removeToSave ? t(' Remove to save.') : '');
  }
  if (message === SegmentErrorMessagesMap.NOT_LEAF) {
    return t('Audience includes non leaf segments.') + (removeToSave ? t(' Remove to save.') : '');
  }

  return message;
};

export const isSegmentErrorMessage = (message: string) => {
  return (
    message === SegmentErrorMessagesMap.NOT_EXISTENT ||
    message === SegmentErrorMessagesMap.MALFORMED ||
    message === SegmentErrorMessagesMap.NOT_READY ||
    message === SegmentErrorMessagesMap.ARCHIVED ||
    message === SegmentErrorMessagesMap.NOT_LEAF
  );
};
